module.exports = __webpack_public_path__ + "img/fashion_55.45db902b.jpg";